const footerStyle = {position: 'fixed',left: 0,bottom: 0,width: '100%', height:'25%',fontFamily : 'Corbel'};
const footerbackcolor = {backgroundColor:'#18406F',height:'75px'};
const formStyle = {margin: 0,position:'relative',width: '50%',left: '25%',fontFamily : 'Corbel'};
const rememberStyle = {marginTop: '4px'};
const rememberTextStyle = {marginLeft: '4px', fontFamily : 'Corbel'};
const forgotStyle = {marginTop: '-5px', fontFamily : 'Corbel'};
const loginStyle = {margin: 'auto', width: '57%'};
const styleElement = {margin : '10px 10px', fontFamily : 'Corbel'};
const innovelSolLogo = {right:'120px',position:'absolute',bottom:'0px', width:'15%'};
const footertop = {};
const footermiddle = {height:'7px',backgroundColor:'#7AC143'};
const footerbottom = {height: '45%'};
const whiteColor = {color:'#FFFFFF', fontFamily : 'Corbel', fontSize:13};
const tangerineColor = {color:'#F15D22',fontSize:16};
const boldFont = {fontWeight : 'bold', fontFamily : 'Corbel'};
const headerStyle = {position:'fixed',top:'0px',left:'0px',right:'0px',width:'100%',bottom:'auto',zIndex:'999'};
const viewStyle = {position:'relative',top:'20px',left:'0px',right:'0px',marginTop:'100px',overflow:'hidden'};
const footerHeight = {left:'0px',right:'0px',bottom:'0px',overflow:'hidden','min-height':'100%', 'min-width':'100%'};
const onlyFontstyleElement = {fontFamily : 'Corbel'};
const textColorFont = {fontFamily : 'Corbel',color : 'black'};
const socialIcon = {height: 30, width: 30};
const headertoppart = {color:'#FFFFFF', backgroundColor:'#7AC143', fontWeight : 'bold', fontFamily : 'Corbel', display: 'flex', 'justify-content': 'center'};
const headerbotompart = {color:'#FFFFFF',backgroundColor:'#18406F',right:'10px'};
// color:'#FFFFFF', backgroundColor:'#18406F'
export default {headerbotompart,headertoppart,socialIcon,textColorFont,onlyFontstyleElement,tangerineColor,headerStyle, viewStyle, footerHeight, boldFont,whiteColor,footerbottom,footermiddle,footertop,innovelSolLogo,footerbackcolor,footerStyle,formStyle,rememberStyle,rememberTextStyle,forgotStyle,loginStyle,styleElement}
